import { Navigate } from "react-router-dom";
import { EmployeesPage } from "./EmployeeList.js";
import { EmployeeProfilePage } from "./EmployeeProfile.js";
import { TimeAssignmentsPage } from "./TimeAssignments.js";
import { TimeClockPage } from "./TimeClock.js";
import { TimeApprovalsPage, TimeWeekPage } from "./TimeWeek.js";
import { ExpensesPage } from "./Expenses.js";

export const employeesRoutes = [
  { path: "employees", element: <EmployeesPage /> },
  { path: "employees/:id", element: <EmployeeProfilePage /> },
  { path: "time", element: <Navigate replace to="/time/clock" /> },
  { path: "time/week", element: <TimeWeekPage /> },
  { path: "time/clock", element: <TimeClockPage /> },
  { path: "time/assignments", element: <TimeAssignmentsPage /> },
  { path: "time/approvals", element: <TimeApprovalsPage /> },
  { path: "expenses", element: <ExpensesPage /> },
];
